var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowLeft = function ArrowLeft(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 9' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Path 2'
      ),
      React.createElement('path', { d: 'M5.122 0L1 4.365l4.122 4.234', stroke: 'currentColor', fill: 'none', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default ArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowLeft.js